function getRandomString(stringLength = 0) {
  const CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

  return new Array(stringLength).fill('').reduce((acc) => acc + CHARACTERS.charAt(Math.floor(Math.random() * CHARACTERS.length)), '');
}

export default {
  getRandomString,
};
